import React from '../helpers/react';
import { connect } from '../helpers/composeReducer.js';
import { pushPath } from 'redux-simple-router';
import { trigger } from '../helpers/events.js';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

export const NoSubSolution = React.createClass({
    triggerCTA : function() {
        trigger('noSubCTA', this.props.problemId);
    },

    gotoFirstProblem: function(){
        const chapterKey = this.props.use_id_identifier ? this.props.chapter.chapterId : this.props.chapter.chapterName;

        this.props.pushPath(this.props.buildRoute('chapter',{
            isbn13  : this.props.isbn13,
            chapter : chapterKey
        }));
    },

    getCTADialog :  function() {
        const chapter = this.props.chapter.chapterName;
        const problem_name = this.props.problemName;

        let link = '';

        if (this.props.show_sample_link) {
            link = <a onClick={this.gotoFirstProblem}>{this.props.getDef('no-sub.sample-solution')}</a>;
        }

        return (
            <section className='dialog'>
                <h1 className='title'>{this.props.getDef('no-sub.problem-info', {chapter, problem_name})}</h1>
                <h2 className='subtitle'>{this.props.getDef('no-sub.subtitle')}</h2>
                <button className='simple-button cta' onClick={this.triggerCTA}>{this.props.getDef('no-sub.cta-button-text')}</button>
                {link}
            </section>
        )
    },

    getMockSteps : function(steps, stepsShown) {
        let result = [];
        let stepsToShow = steps - stepsShown;
        for (let i = 1 + stepsShown; i <= steps; i++) {
            result.push(
                <section className={'step mock-step mock-' + i} key={'mock_step_' + i}>
                    <header>
                        <h4 className="step-header">
                            <span className="step-num">{this.props.getDef('step.title', { index: i }) + ' '}</span>
                            <span className="step-total">{this.props.getDef('step.title-total', { total : steps })}</span>
                        </h4>
                    </header>
                    <div className="content"></div>
                </section>
            )
        }

        return result;
    },

    render : function() {
        const dialog = this.getCTADialog(),
            mock_steps = this.getMockSteps(this.props.total_steps, this.props.steps.length);

        let mainClass = classList('no-sub-solution', getHookClass('NoSubSolution'));
        return (
            <section className={mainClass}>
                { mock_steps }
                { dialog }
            </section>
        );
    }
});

export function mapStateToProps(state){
    const problem = state.problem;
    return {
        ...problem,
        isbn13 : state.model.isbn13,
        show_sample_link : state.options.no_solution_show_sample_link,
        use_id_identifier : state.options.use_id_identifier,
        buildRoute : state.helpers.buildRoute,
        getDef : state.helpers.getDef
    };
}

export default connect(mapStateToProps, { pushPath })(NoSubSolution);



// WEBPACK FOOTER //
// ./src/components/NoSubSolution.js